"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGameServer = void 0;
var _request = _interopRequireDefault(require("../utils/request"));
var _consts = require("../consts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * @Author: ligen
 * @Date: 2022/11/23
 * @Desc:
 */

/**
 *
 * @param {string} status 状态  activation：激活   billing：充值  '':全部
 * @returns
 */
var getGameServer = function getGameServer() {
  var gameId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var isWeGame = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return _request.default.get("".concat(_consts.SQGameServer_URL, "/gameserver/game/").concat(gameId, "/server?status=").concat(status, "&wegame=").concat(isWeGame));
};
exports.getGameServer = getGameServer;